module.exports = __webpack_public_path__ + "img/refresh-cw-02.a9460aab.svg";